import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import Storyboard from './Storyboard';

export default class Storyboards extends React.Component {
  renderStoryboards(storyboards) {
    if (isEmpty(storyboards)) return null;

    return (
      <div>        
        {storyboards.map(storyboard => {
          return (
            <Storyboard
              storyboard={cloneDeep(storyboard)}
              highlight={this.props.highlight}
              highlightDestinationFunc={this.props.highlightDestinationFunc}
              onClickStoryboardFunc={this.props.onClickStoryboardFunc}
              onDeleteStoryboardFunc={this.props.onDeleteStoryboardFunc}
              onCloneStoryboardFunc={this.props.onCloneStoryboardFunc}
            />
          );
        })}
      </div>
    );
  }

  render() {
    const { storyboards = [] } = this.props;

    return <div>{this.renderStoryboards(storyboards)}</div>;
  }
}
